import { Loader2 } from 'lucide-react';

interface SchedulerPaginationNoticeProps {
  /** Whether additional pages of scheduled jobs are still being auto-loaded. */
  isLoadingAll: boolean;
  /** Number of scheduled jobs loaded so far across all fetched pages. */
  loaded: number;
  /** Total scheduled jobs available on the server. */
  total: number;
}

/**
 * Passive, informational notice shown while the scheduler auto-loads the
 * remaining pages of scheduled jobs (WRK-5235). Rather than warning the user to
 * manually check every page, Lite loads them all itself and simply tells the
 * user it's doing so. Renders nothing once loading is complete.
 */
export function SchedulerPaginationNotice({
  isLoadingAll,
  loaded,
  total,
}: SchedulerPaginationNoticeProps) {
  if (!isLoadingAll) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 mb-3 px-3 py-2 rounded-md border border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800 dark:bg-blue-950/30 dark:text-blue-200"
    >
      <Loader2 className="w-4 h-4 flex-shrink-0 animate-spin" />
      <p className="text-sm">
        Loading all scheduled jobs ({loaded} of {total}) so every day shows its full schedule —
        please wait a moment before scheduling new jobs.
      </p>
    </div>
  );
}
